import { gql } from "@apollo/client";

export const GET_PANTALLAS_VISITA = gql`
query pantallasVisita($idTipoProfesional: Int!, $idTipoVisita: Int!, $idTipoModulo: Int!, $idEvaluacion: Int!, $idProfesional: Int!, $idFiguraProfesional: Int!) {
  pantallasVisita(idTipoProfesional: $idTipoProfesional , idTipoVisita: $idTipoVisita, idTipoModulo: $idTipoModulo, idEvaluacion: $idEvaluacion, idProfesional: $idProfesional, idFiguraProfesional: $idFiguraProfesional) {
    idPantallaVisita 
    descripcion 
    nombre 
    componente
  }
}`;

export const parsePantallasVisita = (pantallas) =>
structuredClone(pantallas).map((p) => ({
  idPantallaVisita: p.idPantallaVisita,
  descripcion: p.descripcion,
  displayName: p.nombre,
  componentName: p.componente
}));